import { useTranslate } from '@tolgee/react'
import { Header } from '@tom-ui/ui'

export const OperationalEquipmentHeader = () => {
  const { t } = useTranslate()
  const title = t('operationalEquipment', 'Operational equipment')

  return <Header title={title} position='relative' />
}
